import { ReviewDetails, SortBy } from 'lib/reviews/types';
import { create } from 'zustand';

type Store = {
  exactRating: number;
  pageNumber: number;
  reviews: ReviewDetails[];
  sortOptions: SortBy[];
  usingSupplementalReviews: boolean;
  allFilters: boolean;
  setExactRating: (rating: number) => void;
  setPageNumber: (page: number) => void;
  setReviews: (rs: ReviewDetails[]) => void;
  setSortOptions: (sorts: SortBy[]) => void;
  setUsingSupplementalReviews: (ss: boolean) => void;
  setAllFilters: (af: boolean) => void;
};

export const useReviewSummaryStore = create<Store>()((set) => ({
  exactRating: 0,
  pageNumber: 1,
  reviews: [],
  sortOptions: [
    {
      propertyName: 'review.submissionDate',
      sortExpression: 'DESC',
    },
  ],
  usingSupplementalReviews: false,
  allFilters: true,
  setExactRating: (rating: number) => set(() => ({ exactRating: rating })),
  setPageNumber: (page: number) => set(() => ({ pageNumber: page })),
  setReviews: (rs: ReviewDetails[]) => set(() => ({ reviews: rs })),
  setSortOptions: (sorts: SortBy[]) => set(() => ({ sortOptions: sorts })),
  setUsingSupplementalReviews: (ss: boolean) => set(() => ({ usingSupplementalReviews: ss })),
  setAllFilters: (af: boolean) => set(() => ({ allFilters: af })),
}));
